// Clés ayant une saisie en attente (« element:<id> », « occurrence:<id> »…), lisibles sans attente : ni le temps réel ni un
// rafraîchissement ne doivent écraser l'affichage d'une saisie pas encore envoyée
let pendingKeys = new Set();

export const setPendingKeys = (keys) => {
    pendingKeys = new Set(keys);
};

export const addPendingKeys = (keys) => {
    keys.forEach(key => pendingKeys.add(key));
};

export const isPendingSync = (key) => pendingKeys.has(key);
export const isElementPendingSync = (id) => pendingKeys.has(`element:${id}`);
